import crypto from 'crypto-js';

/**
 * Generate a unique device ID based on browser fingerprint
 * Uses the same logic as TourStartPage for consistency
 */
export function getDeviceId(): string {
  const fingerprint = {
    width: window.screen.width,
    height: window.screen.height,
    language: window.navigator.language,
    platform: window.navigator.platform,
    hardwareConcurrency: window.navigator.hardwareConcurrency
  };

  return crypto.MD5(JSON.stringify(fingerprint)).toString(crypto.enc.Base64);
}
